import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import SupplierForm from '../../components/Suppliers/SupplierForm';
import Toast from '../../components/Common/Toast';

const CreateEntity = () => {
  const navigate = useNavigate();
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  const handleSuccess = () => {
    setToast({ isOpen: true, message: 'Entidad creada exitosamente', type: 'success' });
    setTimeout(() => navigate('/entities'), 1200);
  };

  const handleError = (error) => {
    setToast({
      isOpen: true,
      message: error.response?.data?.message || 'Error al crear la entidad',
      type: 'error',
    });
  };

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Nueva Entidad</h1>
          <p className="text-gray-600 mt-1">Complete el formulario para crear una nueva entidad</p>
        </div>
        <SupplierForm isPageMode showEntityTypes onSuccess={handleSuccess} onError={handleError} />
      </div>
      <Toast
        isOpen={toast.isOpen}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, isOpen: false })}
      />
    </div>
  );
};

export default CreateEntity;

